module.exports = {
    my_property: '我的資產',
    property_total: '資產總折合',
    capital_account: '資金賬戶',
    withdraw: '提現',
    withdraw1: '提現中',
    transfer: '劃轉',
    trading_account: '燃料賬戶',
    trading_account_card: '燃料/点卡账户',
    top_up: '充值',
    // rebate_account:'返傭獎金',
    rebate_account: '點卡',
    top_up_order: '充值訂單',
    withdraw_order: '提現訂單',
    time: '時間',
    type: '類型',
    account: '賬戶',
    kind: '幣種',
    quantity: '數量',
    address: '地址',
    schedule: '進度',
    state: '狀態',
    top_up_success: '充值成功',
    withdraw_success: '提現成功',
    underway: '進行中',
    repeal_withdraw: '撤銷提現',
    record: '記錄',
    record_time: '記錄時間',
    account_type: '賬單類型',
    transaction: '交易類型',
    fee: '扣費',
    property_change: '資產變更',
    account_balance: '賬戶餘額',
    user_fee: '燃料扣費',
    card_fee: '點卡扣费',
    award_money: '花費金額',
    billing_profit: '開單利潤',
    change_address: '變更地址/項目',
    tip: '仅显示7天内的充值/提现订单记录',
    my_capital: '我的資金',
    capital_ratio: '資金比例',
    invite_code: '邀請碼',
    content: '内容',
    combo: '套餐',
    deduct: '扣除',
    buy: '購買',
    waiting_for_payment: '等待支付',
    closed: '已關閉',
    operate: '操作',
    to_pay: '去支付',
    asset_recharge: '資產充值',
    mainnet: '主網',
    wallet_address: '錢包地址（此地址只可接收USDT）',
    important_note: '重要提示：',
    min_deposit: '最少充值金額為50USDT',
    address_check: '請仔細確認地址，充錯無法找回',
    sure: '確定',
    withdrawal_account: '提現賬戶為資金賬戶',
    withdrawal_fee: '提現手續費為提現金額的5%（最低5USDT），從提現金額裡直接扣除',
    withdrawal_address: '請確保您輸入了正確的提幣地址並且您選擇的轉賬網絡與地址相匹配',
    point_card_package: '點卡套餐',
    extra_gift: '加贈',
    selling_price: '售價',
    billing_system: '扣費系統優先扣除點卡賬戶，點卡不足將扣除燃料賬戶',
    card_not_withdraw: '點卡餘額不能提現，不能劃轉，非節點用戶不能贈送。',
    please_select_game_cards: '請選擇要購買的點卡',
    insufficient_funds: '資金賬戶不足，請先充值！',
    purchase_successful: '購買成功',

}
